import { useTranslation } from 'react-i18next';

const useTranslate = () => {
	const { t }: { t: (val: string) => string } = useTranslation();

	return { t };
};

export default useTranslate;
